import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(['visitor', 'visitor-pre-registration', 'grid--vertical'])
}
const _hoisted_2 = { style: {"margin-bottom":"15px"} }
const _hoisted_3 = {
  key: 0,
  style: {"flex-grow":"1"}
}
const _hoisted_4 = {
  class: "el-button is-plain",
  href: "/template/Guest_List_Template.xlsx"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_visiting_companies = _resolveComponent("visiting-companies")!
  const _component_visitor_information = _resolveComponent("visitor-information")!
  const _component_host_information = _resolveComponent("host-information")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_visitor_list = _resolveComponent("visitor-list")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_wrapper_footer = _resolveComponent("wrapper-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_visiting_companies, {
          ref: "visitingCompanies",
          editable: true,
          "tenant-id": _ctx.model.tenantId
        }, null, 8, ["tenant-id"])
      ]),
      _createVNode(_component_el_form, {
        ref: "form",
        "label-position": "top",
        model: _ctx.model,
        class: "info"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_visitor_information, {
            ref: "visitorInformation",
            model: _ctx.model
          }, null, 8, ["model"]),
          _createVNode(_component_host_information, { model: _ctx.model }, null, 8, ["model"])
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_visitor_list, { ref: "visitorList" }, null, 512)
    ]),
    _createVNode(_component_wrapper_footer, null, {
      default: _withCtx(() => [
        (_ctx.hasId)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
              _createVNode(_component_el_button, {
                type: "danger",
                onClick: _ctx.deleteVisitorGroup
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.delete")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("a", _hoisted_4, _toDisplayString(_ctx.trans("label.download-template")), 1),
        _createVNode(_component_el_button, {
          plain: "",
          onClick: _ctx.cancelEditPage
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.cancel")), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_el_button, {
          type: "warning",
          onClick: _ctx.saveVisitor
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, _toDisplayString(_ctx.trans("label.save")), 1)
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    })
  ], 64))
}